import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import CssBaseline from '@material-ui/core/CssBaseline'
import { ThemeProvider } from '@material-ui/styles'
import theme from './Stylesheet/theme'

import './i18n'

ReactDOM.render(
	<ThemeProvider theme={theme}>
		<CssBaseline />
    	<App />
	</ThemeProvider>,
	document.querySelector('#root'),
)